import { Controller } from "@hotwired/stimulus"

// Live-ticking clock for the iPhone mockup's status bar. Updates to the
// current local time on the minute. No-op under prefers-reduced-motion
// (the initial value is fine); the ticking itself is a micro-detail.
export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.render()
    if (this.prefersReducedMotion) return

    const msUntilNextMinute = 60000 - (Date.now() % 60000)
    this.kickoff = setTimeout(() => {
      this.render()
      this.interval = setInterval(() => this.render(), 60000)
    }, msUntilNextMinute)
  }

  disconnect() {
    clearTimeout(this.kickoff)
    clearInterval(this.interval)
  }

  render() {
    if (!this.hasTimeTarget) return
    const now = new Date()
    const h = now.getHours()
    const m = now.getMinutes()
    const h12 = ((h + 11) % 12) + 1
    this.timeTarget.textContent = `${h12}:${String(m).padStart(2, "0")}`
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
